import '../stylesheets/Projects.css'
import ProjectCard from './ProjectCard.js'
import projects from '../json/featured_projects.json';

const Projects = (colorProps) => {
    return <>
        <section id="projects">
            <div className="projects-wrapper">
                <div className="projects-header-wrapper">
                    <div className={"projects-header " + colorProps.color}>
                        <h2 className={"projects-heading " + colorProps.color}>Some Projects </h2>
                        <p className={"alt-text " + colorProps.color}>AND CONTRIBUTIONS</p>
                    </div>
                </div>
                <div className={"project-container"}>
                    {projects ? projects.map((project, index) => (
                        <ProjectCard key={index} {...project} />
                    )) : <></>}
                </div>
            </div>
        </section>
    </>;
}

export default Projects;